import { keysToCamelCase } from '@adjust/dashboard-core/lib/fp';
import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const http = httpFactory({ baseURL: configurationURL.accounts.baseUrl });

export default http;

export const updateAccount = (id, data) => http.put(`/accounts/${id}`, data).then(resp => resp.data);

export const getTermsConfirm = ({ mobileAppId: mobile_app_id, termName: term_name }) =>
  http.get(`/term_confirmation`, { params: { mobile_app_id, term_name } }).then(resp => resp.data);

export const updateTermsConfirm = ({ action, mobileAppId: mobile_app_id, termName: term_name }) =>
  http.post(`/term_confirmation/${action}`, { mobile_app_id, term_name }).then(resp => resp.data);

export const getTimezones = () =>
  http
    .get(`/timezones`, {
      cacheStrategy: 'cacheFirst',
      maxAge: '1 day',
    })
    .then(resp => resp.data);

/**
 * Requests contact of the account manager
 *
 * @param {Number} id Account id
 * @returns {Promise}
 */
export const requestContact = id => {
  const payload = {
    id,
    action: 'contact_request',
  };

  return http.post(`/accounts/${id}/contact_request`, payload).then(resp => resp.data);
};

/**
 * Updates pricing plan
 *
 * @param {Number} id Account Id
 * @param {Number} planId Pricing plan id
 * @param {Boolean} currentPlan Indicates the current pricing plan
 * @returns {Promise}
 */
export const updatePlan = (id, planId, currentPlan) => {
  const payload = {
    id,
    planId,
    current_plan: currentPlan,
    action: 'payment_plans',
  };

  return http.put(`/accounts/${id}/payment_plans/${planId}`, payload).then(resp => resp.data);
};

export const getPlans = id => {
  const payload = {
    id,
    action: 'payment_plans',
  };

  return http
    .get(`/accounts/${id}/payment_plans`, payload)
    .then(resp => resp.data)
    .then(plans => plans.map(keysToCamelCase));
};

export const setMainContact = ({ id, main_contact_id }) =>
  http.put(`/accounts/${id}`, { id, main_contact_id }).then(resp => resp.data);
